import React, { useState, useEffect, useCallback, useRef } from "react";
import ItemTableV2 from "../../components/WhiteLabelComponent/WhiteLabelTable";
import DivisionWiseTable from "../../components/WhiteLabelComponent/DivisionWiseTable";
import DivisionWiseGraph from "../../components/WhiteLabelComponent/DivisionWiseGraph";
import "./ScenerioPage.scss";
import {
	UpdateSaveReason,
	getBCIHistoricalTrend,
	getAPI,
	getProductLevelData,
	getItemLevelData,
	getDivisionLevelData,
} from "../../react-query/api/index";
import HistoricalTrendTable from "../../components/WhiteLabelComponent/HistoricalTrendTable";
import HistoricalTrendGraph from "../../components/WhiteLabelComponent/HitoricalTrendGraph";
import MainContent from "../../components/Layouts/MainContent";
import MainHeader from "../../components/Layouts/MainHeader";
import uparrowFilter from "../../assets/uparrowFilter.svg";
import downarrowFilter from "../../assets/downarrowFilter.svg";
import FilterComponent from "../../components/common/FilterComponent";
import PopupComponent from "../../components/WhiteLabelComponent/PopupComponent";
import Heading from "../../components/common/Heading";
import CustomLoader from "../../components/custom-loader";
import { useLocation } from "react-router-dom";

interface ItemLevelData {
	key: number;
	category: string;
	productType: string;
	InToleranceIndicator: number;
	isUserOverride: number;
	isRecOverride: number;
	itemDesc: string;
	division: string;
	week: string;
	itemId: string;
	itemBrand: string;
	divisionId: number;
	volume: number;
	revenue: number;
	rule: number;
	opportunity: number;
	margin: number;
	minThreshold: number;
	maxThreshold: number;
	cfpMin: number;
	cfpMax: number;
	leadingPrice: number;
	followingPrice: number;
	recOverride: number;
	customerId: string | null;
	newCustomerDesc: string;
	AvgPriceChange: number;
}

const BrandCost: React.FC = () => {
	const [mainData, setMainData] = useState<any[]>([]);
	const [currentDivisionData, setCurrentDivisionData] = useState<any>(null);
	const [clickedItem, setClickedItem] = useState<string | null>(null);
	const [clickedItemDesc, setClickedItemDesc] = useState<string | null>(null);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [updatepopup, setUpdatepopup] = useState<boolean>(false);
	const [categoryFilterValue, setCategoryFilterValue] = useState<any[]>([]);
	const [customerFilterValue, setCustomerFilterValue] = useState<any[]>([]);
	const [categoryDefault, setCategoryDefault] = useState<string>("");
	const [customerDefault, setCustomerDefault] = useState<string>("");
	const [itemidpopup, setItemidpopup] = useState<string>("");
	const [divisionpopup, setDivisionpopup] = useState<string>("");
	const [reason, setReason] = useState<string>("");
	const [week, setWeek] = useState<number>(0);
	const [filterExpansion, setfilterExpansion] = useState<boolean>(true);

	const [state, setState] = useState<any>({
		pageLoading: false,
		divisionData: [],
		divsionTableSUmmaryData: {},
		tableData: [],
		filterData: [],
		bciInfo: { length: 0, opport: 0 },
		enableSave: false,
		tableHeight: 210,
		openPopUp: false,
		openTrendPopUp: false,
		historicalTrendData: [],
		isGoBackLinkVisible: false,
		setGoBackLinkValue: null,
		powerBiSelectedCustomer: "",
	});

	const [itemLevelData, setItemLevelData] = useState<{
		[key: number]: ItemLevelData[];
	}>({});
	const [graphleveldata, setgraphLevelData] = useState<{
		[key: number]: ItemLevelData[];
	}>({});
	const [extendedRows, setExtendedRows] = useState<{
		[key: number]: ItemLevelData[];
	}>({});
	const [expandedData, setExpandedData] = useState<{ [key: number]: any[] }>(
		{}
	);

	const locationValue = useLocation();

	// Use a ref to track initial load
	const initialLoad = useRef(true);

	useEffect(() => {
		const searchedCustomer = new URLSearchParams(locationValue.search).get(
			"customer"
		);
		if (searchedCustomer) {
			setCustomerDefault(searchedCustomer);
		}
	}, [locationValue]);

	const fetchExpandedLevelData = useCallback(
		async (productType: string, index: number) => {
			setState((prev: any) => ({
				...prev,
				pageLoading: true,
			}));
			try {
				const response = await getItemLevelData(productType);
				let updatedData = [...response.data];
				updatedData.map((item) => {
					item.recOverride = "";
				});
				setExpandedData((prev) => ({
					...prev,
					[index]: updatedData,
				}));
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				setState((prev: any) => ({
					...prev,
					pageLoading: false,
				}));
			}
		},
		[]
	);

	const fetchDivisionLevelData = useCallback(
		async (
			index: number,
			productType: string,
			itemId: string,
			fetchedIndex: number,
			itemLevel: any
		) => {
			try {
				setState((prev: any) => ({
					...prev,
					pageLoading: true,
				}));
				const responseData = await getDivisionLevelData({
					productType,
					itemId,
				});
				setgraphLevelData(responseData);
				let updatedResponse = [...responseData.data];
				let sum = 0;
				updatedResponse.map(
					(item: {
						recOverride: { isEditable: boolean; value: any };
					}) => {
						sum += item.recOverride.value;
					}
				);
				let avg = (sum / updatedResponse.length).toFixed(2);
				setExtendedRows((prev) => ({
					...prev,
					[fetchedIndex]: updatedResponse,
				}));
				itemLevel[index][fetchedIndex].recOverride = avg;
				setExpandedData((prev) => ({
					...prev,
					[index]: itemLevel[index],
				}));
				setgraphLevelData((prev) => ({
					...prev,
					[index]: itemLevel[index],
				}));
			} catch (error) {
				console.error("Error fetching division level data:", error);
			} finally {
				setState((prev: any) => ({
					...prev,
					pageLoading: false,
				}));
			}
		},
		[]
	);

	useEffect(() => {
		if (initialLoad.current) {
			initialLoad.current = false;
			const arr = window.location.hash.split("?");
			if (arr.length > 1) {
				const queryParams = arr[1].split("&");
				window.localStorage.setItem(
					"navigateTo",
					arr[0] + "?" + queryParams[0]
				);
				if (queryParams[1] === "close=true") {
					window.close();
				}
				setState((prevState: any) => ({
					...prevState,
					powerBiSelectedCustomer: Number(
						queryParams[0].split("=")[1].replaceAll("%20", " ")
					),
					isGoBackLinkVisible: true,
				}));
			}
			getFilterData();
			const fetchData = async () => {
				try {
					const response = await getProductLevelData({
						currentPage,
						category: categoryDefault,
						customerId: customerDefault,
					});
					setMainData(response.data);
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			};
			fetchData();
			setState((prevState: any) => ({
				...prevState,
				tableHeight: window.innerHeight - 240,
			}));
			const handleResize = () => {
				setState((prevState: any) => ({
					...prevState,
					tableHeight: window.innerHeight - 240,
				}));
			};
			window.addEventListener("resize", handleResize);
			return () => {
				window.removeEventListener("resize", handleResize);
			};
		}
	}, [currentPage, categoryDefault, customerDefault]);

	const handlePageChange = (newPage: React.SetStateAction<number>) => {
		setCurrentPage(newPage);
		setExpandedData({});
		setExtendedRows({});
	};

	const getFilterData = useCallback(() => {
		setState((prevState: any) => ({
			...prevState,
			pageLoading: true,
		}));
		getAPI("/getBCIFIlterData")
			.then((response: any) => {
				setState((prevState: any) => ({
					...prevState,
					pageLoading: false,
				}));
				if (
					response.status === 200 &&
					response.data &&
					response.data.data
				) {
					const filterDataGlobal = response.data.data;
					setFilterData(filterDataGlobal);
				}
			})
			.catch(() => {
				setState((prevState: any) => ({
					...prevState,
					pageLoading: false,
				}));
			});
	}, []);

	const handleDivisionTable = (divisionId: string) => {
		const combinedList = Object.values(extendedRows).flat();
		const currentDataPoints: any[] = combinedList.map((item) => ({
			itemDesc: item.itemDesc,
			itemId: item.itemId,
			divisionId: item.divisionId.toString(),
			volume: item.volume,
			revenue: item.revenue,
			margin: item.margin,
			opportunity: item.opportunity,
		}));
		const divisionLevelData = currentDataPoints?.find(
			(item: any) => item?.divisionId == divisionId
		);
		setCurrentDivisionData(divisionLevelData);
	};

	const handleHistoricalTrendClick = useCallback(
		(data: any) => {
			setState((prevState: any) => ({
				...prevState,
				pageLoading: true,
				openTrendPopUp: true,
			}));
			getBCIHistoricalTrend({
				itemId: clickedItem,
				DivisionID: data.name,
			})
				.then((response: any) => {
					setState((prevState: any) => ({
						...prevState,
						pageLoading: false,
					}));
					if (
						response.status === 200 &&
						response.data &&
						response.data.length
					) {
						setState((prevState: any) => ({
							...prevState,
							historicalTrendData: response.data,
						}));
						handleDivisionTable(data.name);
					}
				})
				.catch(() => {
					setState((prevState: any) => ({
						...prevState,
						pageLoading: false,
					}));
				});
		},
		[clickedItem, extendedRows]
	);

	const setFilterData = (filterDataGlobal: any) => {
		let customerList: any = [];
		setCategoryFilterValue(
			filterDataGlobal.categoryList.map((d: any) => ({
				label: d.name,
				value: d.name,
			}))
		);
		let customerFound = false;
		if (state.powerBiSelectedCustomer) {
			let custObj: any = {};
			filterDataGlobal.categoryList.forEach((d: any) => {
				d.customerList.forEach((customer: any) => {
					if (
						customer.id == customerDefault &&
						customerFound === false
					) {
						customerFound = true;
					}
					if (!custObj[customer.id]) {
						custObj[customer.id] = {
							label: customer.name,
							value: customer.id,
						};
					}
				});
			});
			// setCustomerFilterValue(Object.values(custObj));
		} else {
			let result: any = [];
			filterDataGlobal?.categoryList?.map((each: any) => {
				let localresult = each?.customerList?.map((customer: any) => {
					return {
						label: customer?.id,
						value: customer?.id,
					};
				});
				result = [...result, ...localresult];
			});
			let newCustomerList = result?.filter(
				(customer: { value: any; label: any }) => {
					return customer.value !== null;
				}
			);
			setCustomerFilterValue(newCustomerList);
		}
		const filterTemp = [
			{
				id: "category",
				name: "Category",
				default: categoryDefault,
				type: "multi",
				data: categoryFilterValue,
			},
			{
				id: "customer",
				name: "Customer",
				default: customerDefault,
				type: "single",
				data: customerFilterValue,
			},
		];
		setState((prevState: any) => ({
			...prevState,
			filterData: filterTemp,
		}));
	};

	const handleClose = useCallback(() => {
		setState((prevState: any) => ({
			...prevState,
			updatepopup: false,
			openTrendPopUp: false,
		}));
	}, []);

	const closePopUp = useCallback(() => {
		setUpdatepopup(false);
	}, []);

	const handleSave = async () => {
		const payload = {
			data: [
				{
					itemid: itemidpopup,
					divisionId: divisionpopup,
					fiscalWeek: week,
					reason: reason,
				},
			],
		};
		await UpdateSaveReason(payload);
		setUpdatepopup(false);
	};

	const handleFilterSelection = (value: any, type: string) => {
		if (type == "category") {
			setCategoryDefault(value.join(",") ?? "");
		} else {
			setCustomerDefault(value ?? "");
		}
	};

	const thousands = useCallback(
		(value: any) => `${value}`.replace(/(?=(?!(\b))(\d{3})+\$)/g, "$1,"),
		[]
	);

	const {
		tableData,
		divisionData,
		divsionTableSUmmaryData,
		filterData,
		bciInfo,
		pageLoading,
		enableSave,
		tableHeight,
		openPopUp,
		openTrendPopUp,
		historicalTrendData,
		powerBiSelectedCustomer,
	} = state;

	let projOpp: string = "";
	if (historicalTrendData.length > 0) {
		projOpp = (
			currentDivisionData?.opportunity < 1000
				? Math.round(currentDivisionData?.opportunity * 10) / 10
				: thousands(
					Math.round(currentDivisionData?.opportunity / 1000)
				) + "K"
		).toString();
	}

	return (
		<>
			{pageLoading && (
				<div>
					<CustomLoader open={true} />
				</div>
			)}
			<PopupComponent
				updatepopup={updatepopup}
				itemidpopup={itemidpopup}
				divisionpopup={divisionpopup}
				reason={reason}
				setReason={setReason}
				closePopUp={closePopUp}
				handleSave={handleSave}
			/>
			{openTrendPopUp && (
				<div className="modalBCI trendmodalBCI">
					<div
						id="trendcontent"
						className="modalBCI-content trendPopUpContents"
					>
						<span className="closeBCI" onClick={handleClose}>
							&times;
						</span>
						{historicalTrendData && (
							<span
								className="chart-title subHead"
							>
								Historical CFP for Item - {clickedItemDesc}(
								{clickedItem}) and Division -{" "}
								{historicalTrendData.length > 0
									? historicalTrendData[0].DivisionID
									: ""}
							</span>
						)}
						<div style={{ height: "80%" }}>
							<HistoricalTrendGraph
								data={historicalTrendData}
								handleClick={function (
									event: React.MouseEvent
								): void {
									throw new Error(
										"Function not implemented."
									);
								}}
							/>
						</div>
						<div>
							<HistoricalTrendTable data={historicalTrendData} />
						</div>
						<div style={{ padding: "1rem" }}>
							<span
								className="text-[0.7vw] text-black"

							>
								Projected opportunity at current run rate for
								the next 52 weeks: ${projOpp}
							</span>
						</div>
					</div>
				</div>
			)}
			<MainHeader customClass="relative" headerName="White Label Pricing">
				<div className="w-full">
					{filterExpansion && (
						<div className="flex justify-start items-center gap-[1vw] pb-[2vh]">
							<div className="flex flex-col justify-start items-start">
								<FilterComponent
									type="multi"
									filterName="Category"
									options={categoryFilterValue}
									labelKey="label"
									valueKey="value"
									loading={false}
									onFilterChange={(value: any) => {
										handleFilterSelection(
											value,
											"category"
										);
									}}
								/>
							</div>
							<div className="flex flex-col justify-start items-start">
								<FilterComponent
									type="single"
									filterName="Customer"
									options={customerFilterValue}
									labelKey="label"
									valueKey="value"
									loading={false}
									onFilterChange={(value: any) => {
										handleFilterSelection(
											value,
											"customer"
										);
									}}
									value={[customerDefault]}
								/>
							</div>
						</div>
					)}
				</div>
				{filterExpansion ? (
					<div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer">
						<img
							className="w-[1.5vw]"
							src={uparrowFilter}
							alt="upArrow"
							onClick={() => {
								setfilterExpansion(false);
							}}
						/>
					</div>
				) : (
					<div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer">
						<img
							className="w-[1.5vw]"
							src={downarrowFilter}
							alt="upArrow"
							onClick={() => {
								setfilterExpansion(true);
							}}
						/>
					</div>
				)}
			</MainHeader>

			<MainContent className="bg-[#F1F1F1]" fullHeight={!filterExpansion}>
				<div
					style={{
						display: "flex",
						gap: "2vw",
						alignItems: "center",
					}}
				>
					<div className="chart-title subHead">
						{"White Label Pricing Opportunity"}
					</div>
					<div className="chart-title subHead">Divisionwise Opportunity</div>
				</div>
				<div
					style={{ display: "flex", justifyContent: "space-between" }}
				>
					<div
						style={{
							height: `${filterExpansion ? "60vh" : "68vh"}`,
							flex: 1,
							backgroundColor: "white",
							border: "1px solid #bebebe",
						}}
					>
						<ItemTableV2
							filterExpansion={filterExpansion}
							data={mainData}
							setClickedItem={setClickedItem}
							handleRecAccept={function (
								item: any,
								type: string,
								isAll: boolean,
								pIndex?: number,
								index?: number,
								divIndex?: number
							): void {
								throw new Error("Function not implemented.");
							}}
							handleBCISubmit={function (): void {
								throw new Error("Function not implemented.");
							}}
							expandedData={expandedData}
							extendedRows={extendedRows}
							fetchDivisionLevelData={fetchDivisionLevelData}
							setExpandedData={setExpandedData}
							setItemLevelData={setItemLevelData}
							fetchExpandedLevelData={fetchExpandedLevelData}
							setExtendedRows={setExtendedRows}
							currentPage={currentPage}
							handlePageChange={handlePageChange}
							itemLevelData={itemLevelData}
							setUpdatepopup={setUpdatepopup}
							setItemidpopup={setItemidpopup}
							setDivisionpopup={setDivisionpopup}
							setWeek={setWeek}
							setgraphLevelData={setgraphLevelData}
							setMainData={setMainData}
						/>
					</div>
					<div className={`flex-1 ml-[1%] ${filterExpansion ? "60vh" : "68vh"}`}
					>
						<div
							style={{
								height: "53%",
								backgroundColor: "white",
								border: "1px solid #bebebe",
							}}
							id="graph"
						>
							<DivisionWiseGraph
								itemLevelData={graphleveldata}
								extendedRows={extendedRows}
								handleClick={handleHistoricalTrendClick}
								isFilterExpanded={filterExpansion}
							/>
						</div>
						<div className="h-[2.5%]"></div>
						<div
							style={{
								height: "44.5%",
								backgroundColor: "white",
								border: "1px solid #bebebe",
							}}
						>
							<DivisionWiseTable
								itemLevelData={graphleveldata}
								extendedRows={extendedRows}
							/>
						</div>
					</div>
				</div>
			</MainContent>
		</>
	);
};

export default BrandCost;
